import * as types from '../mutation-types'
import api from '../api'
import Vue from 'vue'

const defaultState = () => ({
  active_cart:{},
  forms:[],
})

const state = {
    is_fetching: false,
    ...defaultState()
}

const mutations = {
  [types.CART_COMPANY_CREATION_FORM_FETCHED](state, payload) {
    let found = _.find(state.forms, form => form.mutation_name == payload.mutation_name)
    if (found == undefined)
      state.forms.push(payload)
    else {
      let idx = _.indexOf(state.forms, found)
      state.forms[idx] = payload
    }
  },

  [types.CART_COMPANY_EDITION_FORM_FETCHED](state, payload) {
    let found = _.find(state.forms, form => form.mutation_name == payload.mutation_name)
    if (found == undefined)
      state.forms.push(payload)
    else {
      let idx = _.indexOf(state.forms, found)
      state.forms[idx] = payload
    }
  },

  [types.CONTRACT_EDITION_FORM_FETCHED](state, payload) {
    let found = _.find(state.forms, form => form.mutation_name == payload.mutation_name)
    if (found == undefined)
      state.forms.push(payload)
    else {
      let idx = _.indexOf(state.forms, found)
      state.forms[idx] = payload
    }
  },

  [types.CONTRACT_INSTRUCTION_EDITION_FORM_FETCHED](state, payload) {
    let found = _.find(state.forms, form => form.mutation_name == payload.mutation_name)
    if (found == undefined)
      state.forms.push(payload)
    else {
      let idx = _.indexOf(state.forms, found)
      state.forms[idx] = payload
    }
  },

  [types.CONTRACT_OPTION_ADDRESSE_CREATION_FORM_FETCHED](state, payload) {
    let found = _.find(state.forms, form => form.mutation_name == payload.mutation_name)
    if (found == undefined)
      state.forms.push(payload)
    else {
      let idx = _.indexOf(state.forms, found)
      state.forms[idx] = payload
    }
  },

  [types.CONTRACT_OPTION_ADDRESSE_EDITION_FORM_FETCHED](state, payload) {
    let found = _.find(state.forms, form => form.mutation_name == payload.mutation_name)
    if (found == undefined)
      state.forms.push(payload)
    else {
      let idx = _.indexOf(state.forms, found)
      state.forms[idx] = payload
    }
  },

  [types.CUSTOMER_EDITION_FORM_FETCHED](state, payload) {
    let found = _.find(state.forms, form => form.mutation_name == payload.mutation_name)
    if (found == undefined)
      state.forms.push(payload)
    else {
      let idx = _.indexOf(state.forms, found)
      state.forms[idx] = payload
    }
  },

  [types.CUSTOMER_ADDRESSE_CREATION_FORM_FETCHED](state, payload) {
    let found = _.find(state.forms, form => form.mutation_name == payload.mutation_name)
    if (found == undefined)
      state.forms.push(payload)
    else {
      let idx = _.indexOf(state.forms, found)
      state.forms[idx] = payload
    }
  },

  [types.CUSTOMER_ADDRESSE_EDITION_FORM_FETCHED](state, payload) {
    let found = _.find(state.forms, form => form.mutation_name == payload.mutation_name)
    if (found == undefined)
      state.forms.push(payload)
    else {
      let idx = _.indexOf(state.forms, found)
      state.forms[idx] = payload
    }
  },

  [types.CUSTOMER_REPRESENTATIVE_CREATION_FORM_FETCHED](state, payload) {
    let found = _.find(state.forms, form => form.mutation_name == payload.mutation_name)
    if (found == undefined)
      state.forms.push(payload)
    else {
      let idx = _.indexOf(state.forms, found)
      state.forms[idx] = payload
    }
  },

  [types.CUSTOMER_REPRESENTATIVE_EDITION_FORM_FETCHED](state, payload) {
    let found = _.find(state.forms, form => form.mutation_name == payload.mutation_name)
    if (found == undefined)
      state.forms.push(payload)
    else {
      let idx = _.indexOf(state.forms, found)
      state.forms[idx] = payload
    }
  },

  [types.CUSTOMER_REPRESENTATIVE_INFOS_EDITION_FORM_FETCHED](state, payload) {
    let found = _.find(state.forms, form => form.mutation_name == payload.mutation_name)
    if (found == undefined)
      state.forms.push(payload)
    else {
      let idx = _.indexOf(state.forms, found)
      state.forms[idx] = payload
    }
  },

  [types.CUSTOMER_REPRESENTATIVE_ADDRESSE_EDITION_FORM_FETCHED](state, payload) {
    let found = _.find(state.forms, form => form.mutation_name == payload.mutation_name)
    if (found == undefined)
      state.forms.push(payload)
    else {
      let idx = _.indexOf(state.forms, found)
      state.forms[idx] = payload
    }
  },

  [types.CUSTOMER_MAINIFICATION_FORM_FETCHED](state, payload) {
    let found = _.find(state.forms, form => form.mutation_name == payload.mutation_name)
    if (found == undefined)
      state.forms.push(payload)
    else {
      let idx = _.indexOf(state.forms, found)
      state.forms[idx] = payload
    }
  },

  [types.LEAD_CONTACT_CREATE](state, payload) {
    let found = _.find(state.forms, form => form.mutation_name == payload.mutation_name)
    if (found == undefined)
      state.forms.push(payload)
    else {
      let idx = _.indexOf(state.forms, found)
      state.forms[idx] = payload
    }
  },

  [types.LEAD_CONTACT_EDIT](state, payload) {
    let found = _.find(state.forms, form => form.mutation_name == payload.mutation_name)
    if (found == undefined)
      state.forms.push(payload)
    else {
      let idx = _.indexOf(state.forms, found)
      state.forms[idx] = payload
    }
  },
}

const actions = {

  create_cart({state}, params) {
    return Vue.axios.post(`carts`, { params })
  },

  fetchActiveCart({state}, params) {
    return Vue.axios.get(`carts/active`, {})
                    .then((response) => state.active_cart = response.data.cart)
  },

  cart_company_create({state, commit}, params)
  {
    return Vue.axios.get(`/carts/${params.cart_id}/company/create`)
                    .then((response) => {
                      commit(types.CART_COMPANY_CREATION_FORM_FETCHED, {
                        mutation_name:types.CART_COMPANY_CREATION_FORM_FETCHED,
                        form:response.data.form
                      })
                    })
  },

  cart_company_edit({state, commit}, params)
  {
    return Vue.axios.get(`/carts/${params.cart_id}/company/edit`)
                    .then((response) => {
                      commit(types.CART_COMPANY_EDITION_FORM_FETCHED, {
                        mutation_name:types.CART_COMPANY_EDITION_FORM_FETCHED,
                        form:response.data.form
                      })
                    })
  },

  contract_edit({state, commit}, params)
  {
    return Vue.axios.get(`/contracts/${params.contract_id}/edit`)
                    .then((response) => {
                      commit(types.CONTRACT_EDITION_FORM_FETCHED, {
                        mutation_name:types.CONTRACT_EDITION_FORM_FETCHED,
                        form:response.data.form
                      })
                    })
  },

  contract_edit_instructions({state, commit}, params)
  {
    return Vue.axios.get(`/contracts/${params.contract_id}/edit_instructions`)
                    .then((response) => {
                      commit(types.CONTRACT_INSTRUCTION_EDITION_FORM_FETCHED, {
                          mutation_name:types.CONTRACT_INSTRUCTION_EDITION_FORM_FETCHED,
                          form:response.data.form
                      })
                    })
  },

  contract_options_edit_instructions({state, commit}, params)
  {
    return Vue.axios.get(`/contracts/${params.contract_id}/options/${params.contract_option_id}/edit_instructions`)
                    .then((response) => {
                      commit(types.CONTRACT_OPTION_INSTRUCTION_EDITION_FORM_FETCHED,
                        {
                            mutation_name:types.CONTRACT_OPTION_INSTRUCTION_EDITION_FORM_FETCHED,
                            form:response.data.form
                        })
                    })
  },

  contract_options_addresse_creation({state, commit}, params)
  {
    return Vue.axios.get(`/contracts/${params.contract_id}/options/${params.contract_option_id}/addresses/create`)
                    .then((response) => {
                      commit(types.CONTRACT_OPTION_ADDRESSE_CREATION_FORM_FETCHED, {
                        mutation_name:types.CONTRACT_OPTION_ADDRESSE_CREATION_FORM_FETCHED,
                        form:response.data.form})
                    })
  },

  contract_options_addresse_edition({state, commit}, params)
  {
    return Vue.axios.get(`/contracts/${params.contract_id}/options/${params.contract_option_id}/addresses/${params.address_id}/edit`)
                    .then((response) => {
                      commit(types.CONTRACT_OPTION_ADDRESSE_EDITION_FORM_FETCHED, {
                        mutation_name:types.CONTRACT_OPTION_ADDRESSE_EDITION_FORM_FETCHED,
                        form:response.data.form})
                    })
  },

  customer_edit({state, commit}, params)
  {
    return Vue.axios.get(`/customers/${params.customer_id}/edit`)
                    .then((response) => {
                      commit(types.CUSTOMER_EDITION_FORM_FETCHED, {
                        mutation_name:types.CUSTOMER_EDITION_FORM_FETCHED,
                        form:response.data.form})
                    })
  },

  customer_addresse_creation({state, commit}, params)
  {
    return Vue.axios.get(`/customers/${params.customer_id}/addresses/create`, {params:params.params})
                    .then((response) => {
                      commit(types.CUSTOMER_ADDRESSE_CREATION_FORM_FETCHED, {
                        mutation_name:types.CUSTOMER_ADDRESSE_CREATION_FORM_FETCHED,
                        form:response.data.form})
                    })
  },

  customer_addresse_edit({state, commit}, params)
  {
    return Vue.axios.get(`/customers/${params.customer_id}/addresses/${params.address_id}/edit`)
                    .then((response) => {
                      commit(types.CUSTOMER_ADDRESSE_EDITION_FORM_FETCHED, {
                        mutation_name:types.CUSTOMER_ADDRESSE_EDITION_FORM_FETCHED,
                        form:response.data.form
                      })
                    })
  },

  customer_representative_create({state, commit}, params)
  {
    return Vue.axios.get(`/customers/${params.customer_id}/representatives/create`)
                    .then((response) => {
                      commit(types.CUSTOMER_REPRESENTATIVE_CREATION_FORM_FETCHED, {
                        mutation_name:types.CUSTOMER_REPRESENTATIVE_CREATION_FORM_FETCHED,
                        form:response.data.form
                      })
                    })
  },

  customer_representative_edit({state, commit}, params)
  {
    return Vue.axios.get(`/customers/${params.customer_id}/representatives/${params.representative_id}/edit`)
                    .then((response) => {
                      commit(types.CUSTOMER_REPRESENTATIVE_EDITION_FORM_FETCHED, {
                        mutation_name:types.CUSTOMER_REPRESENTATIVE_EDITION_FORM_FETCHED,
                        form:response.data.form
                      })
                    })
  },

  customer_representative_edit_infos({state, commit}, params)
  {
    return Vue.axios.get(`/customers/${params.customer_id}/representatives/${params.representative_id}/edit_info`)
                    .then((response) => {
                      commit(types.CUSTOMER_REPRESENTATIVE_INFOS_EDITION_FORM_FETCHED, {
                        mutation_name:types.CUSTOMER_REPRESENTATIVE_INFOS_EDITION_FORM_FETCHED,
                        form:response.data.form})
                    })
  },

  customer_representative_edit_addresse({state, commit}, params)
  {
    return Vue.axios.get(`/customers/${params.customer_id}/representatives/${params.representative_id}/edit_address`)
                    .then((response) => {
                      commit(types.CUSTOMER_REPRESENTATIVE_ADDRESSE_EDITION_FORM_FETCHED, {
                        mutation_name:types.CUSTOMER_REPRESENTATIVE_ADDRESSE_EDITION_FORM_FETCHED,
                        form:response.data.form})
                    })
  },

  customer_representative_mainfication_form({state, commit}, params)
  {
    return Vue.axios.get(`/customers/${params.customer_id}/representatives/${params.representative_id}/mainification_form`)
                    .then((response) => {
                      commit(types.CUSTOMER_MAINIFICATION_FORM_FETCHED, {
                        mutation_name:types.CUSTOMER_MAINIFICATION_FORM_FETCHED,
                        form:response.data.form
                      })
                    })
  },

  lead_contact_create({state, commit}, params)
  {
    return Vue.axios.get(`/leads/${params.lead_id}/contacts/create`)
                    .then((response) => {
                      commit(types.LEAD_CONTACT_CREATE, {
                        mutation_name:types.LEAD_CONTACT_CREATE,
                        form:response.data.form
                      })
                    })
  },

  lead_contact_edit({state, commit}, params)
  {
    return Vue.axios.get(`/leads/${params.lead_id}/contacts/${params.contact_id}/edit`)
                    .then((response) => {
                      commit(types.LEAD_CONTACT_EDIT, {
                        mutation_name:types.LEAD_CONTACT_EDIT,
                        form:response.data.form
                      })
                    })
  },
  // TODO : ADD SUBMITS API CALLS
}

const getters = {
  forms(state)
  {
    return state.forms
  },
  active_cart(state){
    return state.active_cart
  },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}



// WEBPACK FOOTER //
// ./client/store/modules/sandbox.js